<script setup>
import {useRouter} from "vue-router";
import {preventDeviceLogin} from "@/views/device/deviceLoginGuard";

const router = useRouter();

preventDeviceLogin();
router.push({name: 'device:login'});
</script>

<template>
    <div></div>
</template>
